import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/goalsSummarySagas";
import { getGoalValue, getForecastValue } from "../../../../modules/goals/goalsModule";
import GoalsToWatchModule from "../../../global/goalsToWatch/goalsToWatchModule";

export function formatGoalsData(data) {
  return data.map((item) => ({
    id: item.id,
    locationName: item.locationName,
    metricTitle: item.title,
    value: getGoalValue(item),
    projectedValue: getForecastValue(item),
    currentVal: item.currentVal,
    currentValPacing: item.currentValPacing,
    currencySymbol: item.currencySymbol
  }));
}

export function formatList(data) {
  const categories = ["revenue", "attendance", "memberships", "retention"];

  return categories.flatMap((category) =>
    data[category]
      .filter((item) => item.active)
      .map((item) => ({
        preLabel: item.locationName,
        label: item.title,
        value: item.id
      }))
  );
}

const GoalsToWatch = () => {
  const dispatch = useDispatch();
  const {
    goalsList,
    goalsToWatch,
    currentUser,
    currentUser: { singleLocation }
  } = useSelector((state) => state.goalsSummary);
  return (
    <GoalsToWatchModule
      title="Goals to Watch"
      moduleName=".react-section-wrapper.goals-summary"
      checkList={formatList(goalsList)}
      selectHeight="600px"
      data={formatGoalsData(goalsToWatch)}
      defaultCheckedItems={goalsToWatch}
      currentUser={currentUser}
      singleLocation={singleLocation}
      onSubmit={(data) => {
        return dispatch(actionCreators.setGoalsToWatch(data));
      }}
    />
  );
};

export default GoalsToWatch;
